module.exports = "/fonts/NeoSansStd-Regular.eot?687caeaecd0021538d1337c8dab73bc7";